const LocalesConfig = {
  collection: "locales",
  fields: [
    "id",
    "name",
    "currency.name",
    "currency.symbol",
    "currency.symbol_placement",
    "currency.currency_code",
    "currency.win_logic_divider",
    "currency.condition",
    "currency.compare_against",
    "currency.treat_empty_values_as",
    "language"
  ],

  adapter: class Locale {
    constructor(locale) {
      Object.assign(this, locale);
    }
  }
};

export default LocalesConfig;
